import i18n from "@/i18n";
import React, { Component } from "react";
import BasicUpload from "./BasicUpload";
import { Toast } from "antd-mobile-v2";
import "./cpupload.less";

export default class CpImageList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: [...props.fileList],
      visibleImageModel: false,
      modelImageUrl: "",
    };
  }
  onAddImage = () => {
    this.refs["upload"].onClick();
  };
  screenWidth = -1;
  screenHeight = -1;
  // onRemoveImage = (e) => {
  //   const uid = e.target.dataset.uid;
  //   const { fileList } = this.state;
  //   let index;
  //   for (let i = 0, len = fileList.length; i < len; i++) {
  //     if (fileList[i].uid === uid) {
  //       index = i;
  //     }
  //   }
  //   if (index !== -1) {
  //     fileList.splice(index, 1);
  //   }
  //   const { onChange } = this.props;
  //   onChange && onChange([...fileList]);
  // };
  onChange = (file) => {
    // let index = -1;
    // const { file } = this.state;
    // const { maxCount } = this.props;
    // if (typeof maxCount !== 'undefined' && fileList.length >= maxCount) {
    //   return;
    // }
    // for (let i = 0, len = fileList.length; i < len; i++) {
    //   if (fileList[i].uid === file.uid) {
    //     index = i;
    //   }
    // }
    // if (index === -1) {
    //   fileList.push(file);
    // } else {
    //   fileList.splice(index, 1, file);
    // }

    const { onChange } = this.props;
    onChange && onChange([file]);
  };
  //上传进度
  // onProgress = (file) => {
  //   let index = -1;
  //   const { fileList } = this.state;
  //   for (let i = 0, len = fileList.length; i < len; i++) {
  //     if (fileList[i].uid === file.uid) {
  //       index = i;
  //     }
  //   }
  //   if (index !== -1) {
  //     fileList.splice(index, 1, file);
  //     const { onChange } = this.props;
  //     onChange && onChange([...fileList]);
  //   }
  // };
  onShowImageDetail = (e) => {
    const uid = e.target.dataset.uid;
    let index = -1;
    const { fileList } = this.state;
    for (let i = 0, len = fileList.length; i < len; i++) {
      if (fileList[i].uid === uid) {
        index = i;
      }
    }
    if (this.screenWidth === -1) {
      this.screenWidth = window.screen.width;
      this.screenHeight = window.screen.height;
    }
    if (index !== -1) {
      let file = fileList[index];
      this.setState({
        visibleImageModel: true,
        modelImageUrl: file.url,
        previewImageWidth: -1,
        previewImageHeight: -1,
      });
    }
  };
  onHideShowImageDetail = () => {
    this.setState({
      visibleImageModel: false,
    });
  };
  componentDidUpdate = (prevProps) => {
    if (this.props.fileList !== prevProps.fileList) {
      this.setState({
        fileList: [...this.props.fileList],
      });
    }
  };
  renderImageModal = () => {
    const { visibleImageModel, modelImageUrl } = this.state;
    return (
      visibleImageModel && (
        <div
          className="cp-image-preview-bg"
          onClick={this.onHideShowImageDetail}
        >
          <img
            width="100%"
            alt={i18n.t("Preview")}
            src={modelImageUrl}
          />
        </div>
      )
    );
  };
  render() {
    const { fileList, type = "front" } = this.props;
    const file = fileList && fileList[0];
    const titleMap = {
      front: i18n.t("Head face of ID card"),
      end: i18n.t("face of national emblem of identity card"),
    };
    return (
      <>
        <div className="cp-id-image-container">
          <div
            className={
              !file || file.status !== "done"
                ? `cp-id-image-bg cp-id-image-${type}-bg`
                : "cp-id-image-bg"
            }
          >
            {file && file.status === "done" && (
              <img
                alt={i18n.t("Picture")}
                data-uid={file.uid}
                onClick={this.onShowImageDetail}
                src={file.url}
                width="102"
                height="60"
              />
            )}
          </div>
          <div className="cp-id-title">{titleMap[type]}</div>
          <div className="cp-id-upload-btn" onClick={this.onAddImage}>
            {file && file.status === "done"
              ? i18n.t("Replacement>")
              : i18n.t("Upload>")}
          </div>
        </div>
        {this.renderImageModal()}
        <BasicUpload ref="upload" onChange={this.onChange}></BasicUpload>
      </>
    );
  }
}
